<template>
<div>
    <div v-if="!loading && !error">
        <Breadcrumbs main="HR" submain="Asset Management" title="Asset Detail" />

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button> 
        </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex flex-column flex-lg-row" style="gap: 10px;">
                                <div class="image-portion d-flex justify-content-center align-items-center ">
                                    <div v-if="asset_details.image">
                                        <img :src="host + asset_details.image" alt="">
                                    </div>
                                    <div v-else>
                                        <img src="https://placehold.co/300" alt="">
                                    </div>
                                </div>
                                <div class="feature-portion" style="display: flex; flex-direction: column;">
                                    <div class="mb-3" v-if="asset_details.record_type">
                                        <span v-if="asset_details.record_type == 'ASSET'">
                                            <b-badge pill variant="info">{{ asset_details.record_type }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.record_type == 'LOT'">
                                            <b-badge pill variant="secondary">{{ asset_details.record_type }}</b-badge>
                                        </span>
                                    </div>
                                    <h5>{{ asset_details.name }}</h5>

                                    <span class="mt-3" v-if="asset_details.asset_id">Asset ID: <span class="font-weight-bold">{{ asset_details.asset_id }}</span></span>
                                    <span class="mt-3">Asset Type: <span class="font-weight-bold" v-if="asset_details.asset_type">{{ asset_details.asset_type.name }}</span></span>
                                    <span v-if="asset_details.status !== null && asset_details.status !== undefined && asset_details.status !== ''" class="mt-3">Status: 
                                        <span v-if="asset_details.status == 'RETIRED'">
                                            <b-badge pill variant="warning">{{ asset_details.status }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.status == 'AVAILABLE'">
                                            <b-badge pill variant="success">{{ asset_details.status }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.status == 'RETURNED'">
                                            <b-badge pill variant="danger">{{ asset_details.status }}</b-badge>
                                        </span>
                                        <span v-if="asset_details.status == 'ALLOCATED'">
                                            <b-badge pill variant="primary">{{ asset_details.status }}</b-badge>
                                        </span>
                                    </span>
                                    <span class="mt-3">Unit Price: <span class="font-weight-bold" v-if="asset_details.unit_price">{{ asset_details.unit_price }}</span></span>
                                    <span class="mt-3" v-if="asset_details.record_type == 'LOT'">Total Price: <span class="font-weight-bold" v-if="asset_details.cumulative_cost">{{ asset_details.cumulative_cost }}</span></span>
                                    <span class="mt-3" v-if="asset_details.record_type == 'LOT'">Total Units: <span class="font-weight-bold" v-if="asset_details.total_units">{{ asset_details.total_units }}</span></span>
                                    <span class="mt-3" v-if="asset_details.record_type == 'LOT'">Available Units: <span class="font-weight-bold" v-if="asset_details.available_units">{{ asset_details.available_units }}</span></span>
                                    <span class="mt-3">Purchase Date: <span class="font-weight-bold" v-if="asset_details.purchase_date">{{ asset_details.purchase_date }}</span></span>
                                    <!-- <span class="mt-3">Warranty: <span class="font-weight-bold">{{ asset_details.warranty }} {{ asset_details.warranty_type }}</span></span> -->
                                    <span class="mt-3">Manufacture Date: <span class="font-weight-bold" v-if="asset_details.manufacture_date">{{ asset_details.manufacture_date }}</span></span>
                                    <span class="mt-3">Warranty End: <span class="font-weight-bold" v-if="asset_details.warranty_end">{{ asset_details.warranty_end }}</span></span>
                                    <span class="mt-3">Warranty Remaining: <span class="font-weight-bold text-primary" v-if="asset_details.warranty_end">{{ getWarrantyRemaining(asset_details.warranty_end) }} days</span></span>
                                </div>
                            </div>

                            <div v-if="asset_details.details" style="margin-top: 40px;">
                                {{ asset_details.details }}
                            </div>

                            <h6 class="mt-5 mb-3" v-if="asset_details.record_type == 'ASSET'">Allocated User</h6>
                            <div class="row" v-if="asset_details.record_type == 'ASSET'">
                                <div class="col-sm-6" v-if="asset_details.allocated_users?.length > 0">
                                    <div v-for="user in asset_details.allocated_users" :key="user.id" style="width: fit-content;">
                                        <div class="mb-2 badge-style" style="border-radius: 4px;">
                                            <span style="width: fit-content">{{ user.asset_user.first_name}} {{ user.asset_user.last_name}}</span>
                                            <span style="width: 30px; height: 28px; display: flex; justify-content: end; align-items: center;" v-b-tooltip.hover v-b-modal.modal-center-assetallocation @click="deleteAssetAllocation(user.id)" title="Delete">
                                                <b-icon icon="x" style="color: white;"></b-icon>
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <button class="btn btn-primary" @click="getAsset(asset_details)" v-b-modal.modal-employee-allocation>+ Allocate</button>
                                    </div>
                                </div>
                                <div v-else class="col-sm-6">
                                    <button class="btn btn-primary" @click="getAsset(asset_details)" v-b-modal.modal-employee-allocation>Allocate Employee</button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="mt-5 mb-3 d-flex justify-content-start align-items-center">
                                    <h6 class="mr-4 mt-1">Lot Items</h6>
                                    <button class="btn btn-secondary" v-b-modal.modal-lot-creation>Add New Lot</button>
                                </div>
                                <div class="table-responsive datatable-vue" v-if="lot_items.length > 0 && !lot_loading && !lot_error">
                                    <b-table show-empty stacked="md" :items="lot_items" :fields="fields_lot">
                                        <template #cell(id)="row">
                                            {{ row.index + 1 }}
                                        </template>

                                        <template #cell(status)="row">
                                            <span v-if="row.item.status == 'RETIRED'">
                                                <b-badge pill variant="warning">{{ row.item.status }}</b-badge>
                                            </span>
                                            <span v-if="row.item.status == 'AVAILABLE'">
                                                <b-badge pill variant="success">{{ row.item.status }}</b-badge>
                                            </span>
                                            <span v-if="row.item.status == 'RETURNED'">
                                                <b-badge pill variant="danger">{{ row.item.status }}</b-badge>
                                            </span>
                                            <span v-if="row.item.status == 'ALLOCATED'">
                                                <b-badge pill variant="primary">{{ row.item.status }}</b-badge>
                                            </span>
                                        </template>
                                        
                                        <template #cell(allocated_users)="data">
                                            <div v-if="data.item.allocated_users !== null && data.item.allocated_users.length > 0" v-b-modal.modal-employee-allocation @click="getAssetFromLot(data.item)">
                                                <div class="customers">
                                                    <ul>
                                                        <ul v-for="(member, index) in data.item.allocated_users.slice(0, 3)" :key="index">
                                                            <li v-if="member.asset_user.photo" class="d-inline-block" v-b-tooltip.hover :title="member.asset_user.full_name"><img class="img-30 rounded-circle" :src="host + member.asset_user.photo" alt="" data-original-title=""></li>
                                                            <li v-else class="d-inline-block" v-b-tooltip.hover :title="member.asset_user.full_name"><img class="img-30 rounded-circle" src="../../../../assets/images/user/3.jpg" alt="" data-original-title=""></li>
                                                        </ul>
                                                        <li class="d-inline-block ml-2" v-if="data.item.allocated_users.length > 3">
                                                            <p class="f-12">+ {{ data.item.allocated_users.length - 3 }}</p>
                                                        </li>
                                                        <li class="d-inline-block ml-2">
                                                            <div>
                                                                <b-badge pill variant="primary">+ Allocate</b-badge>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div v-else @click="getAssetFromLot(data.item)" v-b-modal.modal-employee-allocation>
                                                <b-badge pill variant="primary">Allocate Employee</b-badge>
                                            </div>
                                        </template>

                                        <template #cell(created_by)="data">
                                            <span v-if="data.item.created_by">
                                                {{ data.item.created_by.full_name }}
                                            </span>
                                        </template>
                                    </b-table>
                                </div>

                            </div>

                            <h6 class="mb-3 mt-5" v-if="asset_details.specification != null">Asset Specifications</h6>
                            <div class="table-container" v-if="asset_details.specification != null">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="parsedDetails()" :fields="fields">
                                        <template #cell(id)="row">
                                            {{ row.index + 1 }}
                                        </template>
                                        <template #cell(name)="row">
                                            <div style="width: 250px;">{{ row.item.name }}</div>
                                        </template>
                                    </b-table>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="content-container-attahment w-100">
                                        <div class="mt-4">
                                            <h6 class="mb-3">Asset Documents</h6>
                                            <div class="table-responsive datatable-vue" v-if="asset_details.asset_attach?.length > 0">
                                                <b-table show-empty stacked="md" :items="asset_details.asset_attach" :fields="field_attachment">
                                                    <template #cell(index)="data">
                                                        {{ data.index + 1 }}
                                                    </template>
                                                    <template #cell(title)="data">
                                                        <a :href="host + data.item.asset_attachment" target="_blank">{{ data.item.attach_title }}
                                                            <br/>
                                                            <small v-if="data.item.note" style="font-style: italic;">Note:{{truncateText(data.item.note, 30)  }}</small>
                                                        </a>
                                                    </template>
                                                    <template #cell(action)="data">
                                                        <div style="display: flex; flex-direction: row; gap:10px">
                                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather>
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </div>

                                            <button v-if="asset_details.asset_attach?.length > 0" class="btn btn-primary" v-b-modal.modal-scrollable-add-document>Upload More</button>
                                            <button v-else class="btn btn-primary" v-b-modal.modal-scrollable-add-document>Add Attachment</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <!-- Allocate Employee Modal -->
        <b-modal id="modal-employee-allocation" hide-footer title="Allocate Employee">
            <div style="display: flex; flex-direction: column; gap: 15px;">
                <div v-if="asset_details.allocated_users !== null">
                    <div class="row">
                        <div class="text-center col-sm-6 w-full" v-for="user in asset_details.allocated_users" :key="user.id">
                            <div class="mb-2 badge-style" style="border-radius: 4px;">
                                <span style="width: fit-content">{{ user.asset_user.first_name}} {{ user.asset_user.last_name}}</span>
                                <span style="width: 30px; height: 28px; display: flex; justify-content: end; align-items: center;" v-b-tooltip.hover v-b-modal.modal-center-assetallocation @click="deleteAssetAllocation(user.id)" title="Delete">
                                    <b-icon icon="x" style="color: white;"></b-icon>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <multiselect v-model="assignedMembers" tag-placeholder="Add member" placeholder="Search or add a member" label="user_name" :max="user_list.length" track-by="id" :options="user_list" :multiple="true" :taggable="true"></multiselect>
                <div class="d-flex justify-content-end ">
                    <button @click="assignMember" class="btn btn-primary" style="width: 120px;">Allocate</button>
                </div>
            </div>
        </b-modal>

        <!-- Asset Allocate Delete Modal -->
        <b-modal id="modal-center-assetallocation" centered hide-header @ok="handleAssetDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this asset allocation?</div>
        </b-modal>

        <!-- New Lot Create -->
        <b-modal id="modal-lot-creation" ref="modal" title="Add New Lot" @ok="handleLotOk">
            <form ref="form" @submit.stop.prevent="handleLotSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Quantity</label>
                            <input class="form-control" type="number" placeholder="Enter quantity" v-model="new_lot.quantity">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Unit Price</label>
                            <input class="form-control" type="number" placeholder="Enter unit price" v-model="new_lot.unit_price">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Lot Source</label>
                            <select class="form-control digits" v-model="new_lot.lot_source">
                                <option v-for="(source, index) in lot_sources" :key="index">{{ source }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>

        <!-- Project Attachment Create -->
        <b-modal id="modal-scrollable-add-document" ref="modal" title="Add Document" @ok="handleAttachOk">
            <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Supporting note </label>
                            <input class="form-control" type="text" placeholder="Enter supporting note ..." v-model="add_attachment.note">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>Upload project file</label>
                            <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
    <div v-else style="width: 100%;">
        <div class="container-fluid">
            <div class="row flex-md-row-reverse">
                <div class="loader-wrapper">
                    <div class="loader-index">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { myHost } from "../../../../_helpers/host";
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            fields_lot: [
                {
                    key: 'id',
                    label: '#'
                },
                {
                    key: 'asset_id',
                    label: 'Asset ID',
                    sortable: false
                },
                {
                    key: 'lot_number',
                    label: 'Lot Number',
                    sortable: false
                },
                {
                    key: 'unit_price',
                    label: 'Unit Price',
                    sortable: false
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: false
                },
                {
                    key: 'allocated_users',
                    label: 'Allocated User',
                    sortable: true
                },
                {
                    key: 'created_by',
                    label: 'Created By',
                    sortable: true
                },
            ],
            fields: [
                {
                    key: 'id',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Item',
                    sortable: false
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: false
                }
            ],
            field_attachment: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                }
            ],
            add_attachment: {
                asset_attachment: null,
                asset_id: '',
                note:null,
            },
            new_lot: {
                quantity: null,
                unit_price: null,
                lot_source: 'MANUAL'
            },
            lot_sources: [
                "MANUAL", "GRN"
            ],
            asset: {},
            asset_id: null,
            asset_allocation_id: null,
            assignedMembers: [],
            member: [],
            for_asset: true
        };
    },

    mounted() {
        this.$store.dispatch("asset/fetchAssetDetails", this.$route.params.id);
        this.$store.dispatch("asset/fetchAssetLot", this.$route.params.id);
        this.$store.dispatch("employee/fetchEmployeeList");
    },

    computed: {
        ...mapState({
            asset_details: state => state.asset.asset_detail,
            loading: state => state.asset.submitLoading,
            error: state => state.asset.submitError,
            lot_items: state => state.asset.asset_lot,
            lot_loading: state => state.asset.lotLoading,
            lot_error: state => state.asset.lotError,
            user_list: state => state.employee.employee_list
        })
    },

    watch: {
        asset_details(newValue, oldValue) {},
        'asset_details.specification': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.parsedDetails();
            }
        }
    },

    methods: {
        getAsset(asset) {
            this.asset_id = asset.id,
            this.asset = asset
            this.for_asset = true
        },

        getAssetFromLot(asset) {
            this.asset_id = asset.id,
            this.asset = asset
            this.for_asset = false
        },

        assignMember() {
            const idArray = this.assignedMembers.map(item => this.member.push({
                asset_user: item.id,
                asset: this.asset_id
            }));

            this.$store.dispatch("asset/assetAllocate", {
                member: this.member,
                asset_id: this.$route.params.id,
                for_asset: this.for_asset
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedMembers = [],
                    this.member = []
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-employee-allocation')
            })
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        
        getWarrantyRemaining(warrantyEndDate) {
            const endDate = new Date(warrantyEndDate);
            const currentDate = new Date();
            const timeDifference = endDate.getTime() - currentDate.getTime();
            const remainingDays = Math.ceil(timeDifference / (1000 * 3600 * 24)); // Convert milliseconds to days
            return remainingDays >= 0 ? remainingDays : 0;
        },

        uploadAttachFile(e) {
            this.add_attachment.asset_attachment = e.target.files[0]
        },

        handleAttachOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.add_attachment.asset_id = this.$route.params.id
            this.$store.dispatch("asset/addAssetAttachment", {
                attachment: this.add_attachment,
                asset_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.add_attachment.requisition_attachment = null
                    this.add_attachment.note = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        },

        handleLotOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleLotSubmit()
        },

        handleLotSubmit() {
            this.$store.dispatch("asset/addAssetLot", {
                lot: this.new_lot,
                asset_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.new_lot.quantity = null
                    this.new_lot.unit_price = null
                    this.new_lot.lot_source = 'MANUAL'
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-lot-creation')
            })
        },

        deleteAttach(id) {
            this.$store.dispatch("asset/deleteAttachmentFromAsset", {
                id: id,
                asset_id: this.$route.params.id,

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        parsedDetails() {
            try {
                let details = JSON.parse(this.asset_details.specification);
                return details

            } catch (error) {
                console.error('Error parsing details:', error);
            }
        },

        deleteAssetAllocation(id) {
            this.asset_allocation_id = id
        },

        handleAssetDeleteOk() {
            this.$store.dispatch("asset/deleteAssetAllocation", {
                id: this.asset_allocation_id,
                asset_id: this.$route.params.id,
                from_detail: true,
                for_asset: true
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.asset_allocation_id = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-center-assetallocation')
            })
        },

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.asset.image = e.target.result;
            };
        },

        onSubmit(event) {
            event.preventDefault()
            alert(JSON.stringify(this.asset))
        }
    }
};
</script>

<style scoped>
.asset-container {
    display: flex;
    flex-direction: row;
    gap: 32px
}

.image-portion {
    width: 40%;
}

.image-portion img {
    max-height: 400px;
}

.feature-portion {
    width: 60%;
}

@media screen and (max-width: 991px) {
    .asset-container {
        display: flex;
        flex-direction: column;
    }

    .image-portion {
        width: 100%;
    }

    .feature-portion {
        width: 100%;
    }
}

.badge-style {
    display: flex;
    width: fit-content;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;

}

.badge-style:hover {
    background-color: #ff595d;
}
</style>
